import { useContext, useEffect, useState, useCallback } from 'react';

import OARangePicker from '../../../components/OARangePicker';
import OAToolbar from '../../../components/widgets/OAToolbar';
import FlightContext from '../context/HotelContext';
import { HotelOrderHistory } from './hotelOrderHistory';
import BreadcrumbItem from './BreadcrumbItem';
import OAButton from '../../../components/widgets/OAButton';
import HotelContext from '../context/HotelContext';
import { IHotelQueryParams } from '../type';

interface IHotelsDashboardProps {
  data: {
    queryParams: IHotelQueryParams;
    setQueryParams: (params: IHotelQueryParams | ((prev: IHotelQueryParams) => IHotelQueryParams)) => void;
  };
}

export const HotelsDashboard = ({ data }: IHotelsDashboardProps) => {
  const { queryParams, setQueryParams } = data;
  const { getHotelOrderList, downloadReport, report } = useContext(HotelContext);

  const [list, setList] = useState<Array<any>>([]);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchHotelList = useCallback(() => {
    setIsLoading(true);
    getHotelOrderList(res => {
      setIsLoading(false);
      setList(res);
      setTotalPage(res?.totalPages ?? 0);
    });
  }, [getHotelOrderList]);

  useEffect(() => {
    if (queryParams?.dateRange?.[0] && queryParams?.dateRange?.[1]) {
      fetchHotelList();
    }
  }, [queryParams, fetchHotelList]);

  const onChangeRangePicker = useCallback((range: any) => {
    setQueryParams((prev: any) => ({ ...prev, dateRange: range }));
  }, [setQueryParams]);

  return (
    <>
      <OAToolbar
        title="Hotels"
        breadcrumb={BreadcrumbItem()}
        actionsElement={
          <div className="d-flex">
            <div className="me-4">
              <OARangePicker
                className="dashboard-data-range-filter"
                name="dashboard-data-range"
                onChangeRangePicker={onChangeRangePicker}
                dateRange={queryParams?.dateRange}
                maxDate={new Date()}
              />
            </div>
            <div className="ms-4">
              <OAButton
                label="Report"
                icon="/media/icons/duotune/files/fil021.svg"
                iconClassName="svg-icon-3 me-2"
                loadingText="generating..."
                isLoading={report?.isLoading}
                onClick={downloadReport}
                className="btn btn-sm btn-flex btn-light btn-primary fw-bolder"
                disabled={report?.isLoading}
              />
            </div>
          </div>
        }
      />
      <HotelOrderHistory
        list={list}
        totalPage={totalPage}
        queryParams={queryParams}
        setQueryParams={setQueryParams}
        onChangeRangePicker={onChangeRangePicker}
        loading={isLoading}
      />
    </>
  );
};
